import { getLinkPreview, LinkPreview } from "@/entities/message/api/link-preview";
import { useEffect, useRef, useState } from "react";
import { extractFirstUrl } from "./extract-url";

export const useLinkPreview = (text?: string) => {
  const [preview, setPreview] = useState<LinkPreview | null>(null);
  const requestedRef = useRef<string | null>(null);

  useEffect(() => {
    if (!text) return;

    const url = extractFirstUrl(text);
    if (!url) return;

    if (requestedRef.current === url) return;
    requestedRef.current = url;

    getLinkPreview(url).then((res) => {
      if (res.success) {
        setPreview(res.result);
      }
    })
    .catch(e => {
        console.error(e);
    })
    ;
  }, [text]);

  return preview;
};
